export default __webpack_public_path__ + "static/media/mobile-home-one.78ebb0b1.png";